import { useSessionStore } from '@/stores/session.store'
import type { UserSession } from '@/types/models'

/** The signed-in user, or null for a guest. Re-renders only when the user object changes. */
export function useUser(): UserSession | null {
  return useSessionStore((s) => s.user)
}

export function useIsLandlord(): boolean {
  return useSessionStore((s) => s.user?.defaultProfile === 'landlord')
}
